<div class="p-16-0 hs-8 flex j-flex-end">
  <ng-content select="app-container-group-toggle"></ng-content>
</div>

<ng-content></ng-content>
